import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import Arrow from "../../../../assets/images/arrow.png";
import { useTranslation } from "react-i18next";
import CustomInput from "../../../CustomComponents/FormInputs";
import Card from "../../../CustomComponents/Card";
import addLineBreaks, {
  handleAmountInputLimitTo2decimal,
} from "../../../../utils";
import {
  GetApiHeadersWithOutBearer,
  GetRequest,
  PostRequest,
} from "../../../../network/NetworkUtils";

import { useSelector } from "react-redux";
import Loader from "../../../CustomComponents/Loader";
import {
  appTheme,
  generateRegexExpression,
} from "../../../../helpers/utils/Utils";
import { fetchConfigarationData } from "../../../../helpers/utils/Utils";
import { useKeyDown } from "../../../../hooks/useKeyDown";
import cardDetails from "../../../../assets/smi-kudzu-images/cardDetails.png";
const appConfigData = await fetchConfigarationData();
// const appConfigData = await fetchConfigarationData();
const LocateMyCardDetails = ({ gotItLocateMyCardDetails }) => {
  const { t } = useTranslation();
  const appConfigData = useSelector((state) => state.appConfigData);
  const SubTittleStylesModal =
    "font-serif-pro lg:text-[31px] md:text-[26px] sm:text-[22px] text-[25px] lg:leading-[38px] md:leading-[33px] sm:leading-[29px] leading-[31px] font-normal sm:text-[var(--text-clr-secondary)] text-[var(--text-clr-secondary3)]";
  const userId = useSelector((state) => state.userId);
  const [isLoading, setIsLoading] = useState(false);
  const [policyCriteria, setPolicyCriteria] = useState({});
  const [isLastDigitEntered, setIsLastDigitEntered] = useState(false);
  const newPasswordRef = useRef(null);
  const repeatPasswordRef = useRef(null);
  const signUpkudzuPlusTrue = useSelector(
    (state) => state.isSignUpKudzuplusTrue
  );
  const appThemeData = appTheme(signUpkudzuPlusTrue);
  const isFromSmiOne = useSelector((state) => state.fromSmiOne);
  const [lastDigit, setLastDigit] = useState();
  const [expirationDate, setExpirationDate] = useState();
  const {
    register,
    formState: { errors },
  } = useForm({});

  const handlePasswordChange = (e) => {};

  const handleRepeatPasswordChange = (e) => {};

  return (
    <div className="sm:px-[6%] md:py-10 sm:py-12 flex flex-wrap sm:flex-nowrap scroll-mt-0">
      <Card
        cardHeight={"auto"}
        isWhiteForSignup={appThemeData.isWhiteBgForCard}
        isDarkForKudzu={appThemeData.isDarkBgForCard}
        backgroundColor={"--modalcard-bg"}
        // Cardcaption={ }
        header={true}
        footer={true}
        CardRadius={true}
        // isLogo={isFromSmiOne ? true  : false}
        cardWidth={"69.2%"}
      >
        <div>
          <p
            className={`font-hanken-grotesk text-[var(--locate-my-card)] 
       lg:text-[16px] md:text-[16px] sm:text-[9px] text-[13px]  font-[600]  my-7 `}
          >
            {t("Card_Information")}
          </p>
          <p
            className={`font-hanken-grotesk text-[var(--locate-my-card)] 
       lg:text-[16px] md:text-[16px] sm:text-[9px] text-[13px]  font-[600]   `}
          >
           <span className="mr-2">A</span> {t("last_four_Digits")}
          </p>
          <p
            className={`font-hanken-grotesk text-[var(--locate-my-card)] 
       lg:text-[16px] md:text-[16px] sm:text-[9px] text-[13px]  font-[600]   `}
          >
           <span className="mr-2">B</span> {t("card_Expiration_Date")}
          </p>
        </div>
        <div>
          <div className=" flex flex-col justify-center items-center w-full mt-16 ">
            <img
              src={cardDetails}
              id="card-image"
              className="md:w-[449.7px] sm:w-[250px] lg:h-[251.75px] md:h-[275px] sm:h-[158px] w-full h-full lg:rounded-[30px] md:rounded-[25px] sm:rounded-[20px] rounded-[15px]"
            />
          </div>
        </div>
        <div className=' flex flex-col gap-4 justify-center items-center  w-full my-24'>
        <button autoFocus class="focus:outline-none   font-hanken-grotesk lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] font-[500] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px]   text-[#2965FB] cursor-pointer border-[2.5px] md:py-4 lg:py-4 sm:py-2 px-2 py-3 border-[#2965FB] w-full" onClick={gotItLocateMyCardDetails} >{t("GotIt")}</button>
        </div>
      </Card>
      {isLoading && <Loader />}
    </div>
  );
};

export default LocateMyCardDetails;
